import * as yup from 'yup';
import { API as yachts } from '../../yachts/api';
import { API as marina } from '../../marina/api';
import { DefaultStatusBooking, StatusBooking, AreaOptions, DefaultAreas } from './Data.conf';
import { API as users_nautica } from '../../users_nautica/api';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { API as provenanceList } from '../../provenenceLists/api';

dayjs.extend(utc);
dayjs.extend(isSameOrAfter);

export const FilterConf = {
  schema: yup.object({
    id_yacht: yup.array().nullable(),
    id_agent_NA: yup.array().nullable(),
    start_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      }),
    end_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test(
        'end-after-start',
        "End date can't be before Start date",
        function (value) {
          const { start_date } = this.parent;

          if (!value || !start_date) return true;
          return dayjs(value).isSameOrAfter(dayjs(start_date));
        }
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      }),
    booking_status: yup.array().nullable(),
    id_marina: yup.array().nullable(),
    id_user_provision: yup.array().nullable(),
    provenance: yup.array().nullable(),
    area: yup.array().nullable(),
  }),
  initialState: {
    value: {
      id_yacht: null,
      id_agent_NA: [],
      start_date: dayjs.utc().format('YYYY-MM-DD').toString(),
      end_date: dayjs.utc().endOf('year').format('YYYY-MM-DD HH:mm:ss').toString(),
      booking_status: DefaultStatusBooking,
      id_marina: [],
      id_user_provision: [],
      provenance: null,
      area: DefaultAreas,
    },
  },
  fields: [
    {
      id: 'id_yacht',
      name: 'id_yacht',
      type: 'async_autocomplete_multiple',
      label: 'Yacht',
      api: yachts.selectWithAttendances,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'id_agent_NA',
      name: 'id_agent_NA',
      type: 'async_autocomplete_multiple',
      label: 'NA Agency',
      api: users_nautica.selectName,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'id_user_provision',
      name: 'id_user_provision',
      type: 'async_autocomplete_multiple',
      label: 'Sales Agent',
      api: users_nautica.selectName,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'booking_status',
      name: 'booking_status',
      type: 'autocomplete_multiple',
      label: 'Status Operation Booking',
      options: StatusBooking,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'id_marina',
      name: 'id_marina',
      type: 'async_autocomplete_multiple',
      label: 'Location',
      api: marina.select,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'start_date',
      name: 'start_date',
      type: 'date_time',
      label: 'Start Date',
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'end_date',
      name: 'end_date',
      type: 'date_time',
      label: 'End Date',
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'provenance',
      name: 'provenance',
      type: 'async_autocomplete_multiple',
      label: 'Provenance',
      api: provenanceList.provenences,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'area',
      name: 'area',
      type: 'autocomplete_multiple',
      label: 'Area',
      options: AreaOptions,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
  ],
  query: {
    keys: [
      {
        key: 'id_yacht.id',
        value: 'id_yacht.id',
        operator: '$eq',
      },
      {
        key: 'id_yacht.id_attendance.id_agent_NA.id',
        value: 'id_agent_NA.id',
        operator: '$eq',
      },
      {
        key: 'booking_status',
        value: 'booking_status.label',
        operator: '$eq',
      },
      {
        key: 'id_marina.id',
        value: 'id_marina.id',
        operator: '$eq',
      },
      {
        key: 'check_in_date',
        value: 'end_date',
        operator: '$lte',
      },
      {
        key: 'check_out_date',
        value: 'start_date',
        operator: '$gte',
      },
      {
        key: 'id_yacht.id_attendance.id_user_provision.id',
        value: 'id_user_provision.id',
        operator: '$eq',
      },
      {
        key: 'id_yacht.id_attendance.id_provenence_list.provenence.id',
        value: 'provenance.id',
        operator: '$eq',
      },
      {
        key: 'id_marina.area',
        value: 'area.id',
        operator: '$eq',
      },
    ],
  },
};
